<template>
  <v-tooltip bottom v-if="difference.length > 0">
    <template v-slot:activator="{ on, attrs }">
      <v-btn outlined x-small fab dark class="red" v-on="on">
        <v-icon>mdi-alert-circle</v-icon>
      </v-btn>
    </template>
    <span
      >Ce groupe est dans un projet différent de ceux de son animateur, veuillez
      lui attribuer un projet ou changez son animateur</span
    >
  </v-tooltip>
</template>

<script>
export default {
  props: {
    groupe: {
      required: true,
    },
    animateur: {
      required: true,
    },
  },

  computed: {
    groupesDeProjets() {
      var groupesDeProjets = [];
      this.groupe.projets.forEach(function (item) {
        groupesDeProjets.push(item.id);
      });
      return groupesDeProjets;
    },
    groupesDeAnimateur() {
      var groupesDeAnimateur = [];
      this.animateur.projets.forEach(function (item) {
        groupesDeAnimateur.push(item.id);
      });
      return groupesDeAnimateur;
    },

    difference() {
      return _.differenceWith(
        this.groupesDeProjets,
        this.groupesDeAnimateur,
        _.isEqual
      );
    },
  },
};
</script>

<style scoped></style>
